import { useEffect, useState } from "react";
import EventService from "../services/EventService";

export function useAdjust() {
	const [adid, setAdid] = useState("");
	const [isSkippable, setIsSkippable] = useState(false);

	useEffect(() => {
		getAttributes();
	}, []);

	async function getAttributes() {
		if (isSkippable) return;

		const adjust = await EventService.getAttributesAdjust();

		if (adjust.skip) setIsSkippable(adjust.skip);

		if (!adjust.skip && adjust && adjust.adid) setAdid(adjust.adid);
	}

	return { adid };
}
